import Cookies from 'js-cookie'
export const defaultLocale = 'ko_KR'

export const languageToLocales = {
  en: 'EN',
  ja: 'JP',
  ko: 'KR',
}

export const localeToLanguages = {
  en: 'en',
  en_US: 'en',
  ja: 'ja',
  ja_JP: 'ja',
  ko: 'ko',
  ko_KR: 'ko',
}

export class Locale {
  static getLanguage() {
    const userLocale = Cookies.get('userLocale')
    if (!userLocale) {
      Cookies.set('userLocale', defaultLocale)
    }
    return localeToLanguages[userLocale] || Locale.getDefaultLanguage()
  }

  static getLocale() {
    const language = Locale.getLanguage()
    return languageToLocales[language]
  }

  static getDefaultLanguage() {
    return localeToLanguages[defaultLocale]
  }
}
